module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.d176f3e4.jpg";